import { Link, useRouteError } from "react-router";

import { PublicFooter } from "@/components/layout/PublicFooter";

export function RouteErrorFallback() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : "The app could not load this view.";

  return (
    <div className="flex min-h-dvh flex-col bg-canvas text-primary">
      <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col justify-center px-4 py-12">
        <p className="text-sm font-medium text-tertiary">Invoice Builder</p>
        <h1 className="mt-3 text-2xl font-semibold tracking-tight">This view could not load</h1>
        <p className="mt-3 max-w-xl text-sm leading-6 text-secondary">
          Refresh the page and try again. If the problem continues, return to the invoice dashboard
          and reopen the tool.
        </p>
        <p className="mt-4 rounded-md border border-border bg-elevated px-3 py-2 text-xs text-tertiary">
          {message}
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <button
            type="button"
            className="rounded-md bg-accent px-4 py-2 text-sm font-medium text-accent-fg"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
          <Link
            to="/app"
            className="rounded-md border border-border px-4 py-2 text-sm font-medium text-secondary hover:text-primary"
          >
            Open invoices
          </Link>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
